import ApplicationsList from "./ApplicationsList";

export default ApplicationsList